export enum MatchEventType {
  COMMENT = 1,
  GOAL = 2,
  RED_CARD = 3,
  YELLOW_CARD = 4,
  ASSIST = 5,
  OFFSIDE = 6,
  OWN_GOAL = 8,
  PENALTY = 9,
  PENALTY_GOAL = 10,
  PENALTY_MISS = 11,
  SECOND_YELLOW_CARD = 12,
  DISALLOWED_GOAL = 13,
  MATCH_KICKS_OFF = 14,
  HALF_TIME = 15,
  MATCH_ENDS = 16,
  SECOND_HALF_ENDED = 17,
  HALF_TIME_EXTRA_TIME = 18,
  PENALTIES = 19,
  EXTRA_TIME_ENDED_MATCH_GOES_TO_PENALTIES = 20,
  PLAYER_OFF = 23,
  PLAYER_ON = 24,
  CORNER = 25,
  SECOND_HALF = 26,
  FIRST_HALF_EXTRA_TIME = 28,
  SECOND_HALF_EXTRA_TIME = 29,
  PENALTIES_GOAL = 30,
  PENALTIES_MISS = 31,
  PENALTIES_PENALTY = 32,
  FREE_KICK = 41,
  LINEUP_READY = 43,
  WITHDRAWN_RED_CARD = 44,
  WITHDRAWN_YELLOW_CARD = 45,
  WITHDRAWN_SECOND_YELLOW_CARD = 46,
  SECOND_YELLOW_CARD_CHANGED_TO_FIRST_YELLOW_CARD = 47,
  INDIRECT_ASSIST = 48,
  VAR = 123,
  OFFENCE = 124,
  FOULED = 125,
  INJURY_TIME = 126,
  PENALTY_SAVE = 130,
  MATCH_SUMMARY = 500,
}

export const secondaryEvents: MatchEventType[] = [
  MatchEventType.PLAYER_ON,
  MatchEventType.ASSIST,
  MatchEventType.INDIRECT_ASSIST,
  MatchEventType.PENALTY_GOAL,
  MatchEventType.FOULED,
  MatchEventType.OFFENCE,
];

export const tertiaryEvents: MatchEventType[] = [MatchEventType.PENALTY_SAVE];

export const matchStatusEvents: MatchEventType[] = [
  MatchEventType.MATCH_KICKS_OFF,
  MatchEventType.HALF_TIME,
  MatchEventType.SECOND_HALF,
  MatchEventType.MATCH_ENDS,
  MatchEventType.FIRST_HALF_EXTRA_TIME,
  MatchEventType.HALF_TIME_EXTRA_TIME,
  MatchEventType.SECOND_HALF_EXTRA_TIME,
  MatchEventType.LINEUP_READY,
];

export const substitutionEvents: MatchEventType[] = [MatchEventType.PLAYER_OFF, MatchEventType.PLAYER_ON];

export const uneditableAndNonDeletableEvents: MatchEventType[] = [MatchEventType.LINEUP_READY];

export const importantMatchEventTypeIds: MatchEventType[] = [
  MatchEventType.GOAL,
  MatchEventType.DISALLOWED_GOAL,
  MatchEventType.RED_CARD,
  MatchEventType.YELLOW_CARD,
  MatchEventType.SECOND_YELLOW_CARD,
  MatchEventType.PENALTY,
  MatchEventType.PENALTY_MISS,
  MatchEventType.PENALTY_GOAL,
  MatchEventType.PENALTIES_MISS,
  MatchEventType.PENALTIES_GOAL,
  MatchEventType.WITHDRAWN_RED_CARD,
  MatchEventType.WITHDRAWN_YELLOW_CARD,
  MatchEventType.WITHDRAWN_SECOND_YELLOW_CARD,
  MatchEventType.SECOND_YELLOW_CARD_CHANGED_TO_FIRST_YELLOW_CARD,
  MatchEventType.ASSIST,
  MatchEventType.INDIRECT_ASSIST,
  MatchEventType.SECOND_HALF_ENDED,
];
